export default __webpack_public_path__ + "static/media/arrow-up.cd55477c.svg";